import { SubscriptionTier } from '@heidi/schema/ml-scribe';
import { useQueryUserBillingInfo } from './query/useQueryUserBillingInfo';

export function useIsFreeUser() {
  const { data: billingInfo } = useQueryUserBillingInfo();

  return {
    isFreeUser: billingInfo?.third_party_license?.latest_tier
      ? billingInfo?.third_party_license?.latest_tier === SubscriptionTier.FREE
      : billingInfo?.tier === SubscriptionTier.FREE,
  };
}
